<template>
  <div class="title">
    <span
      v-if="!allBooks"
      v-tooltip="{
        content: getNameListBook,
        placement: 'top',
      }"
      >{{ getNameListBook }}</span
    >
    <span
      v-if="allBooks"
      v-tooltip="{
        content: $t('freeSearchInput.searchIn.allBooks'),
        placement: 'top',
      }"
      >{{ $t("freeSearchInput.searchIn.allBooks") }}</span
    >
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters("bookList", ["getNameListBook", "getDataOfCurrentList"]),
    ...mapState("bookList", ["historyUsersActions", "textSearch"]),
    allBooks() {
      return (
        this.getDataOfCurrentList.data.content == "" && this.textSearch == ""
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
